<template>
  <div :class="(is_show ? 'blueBorder' : '') + ' automobile'" :style="{ width: width + 'px' }" ref="option">
    <a class="defaultText" href="javascript:;" @click="toggle">{{
      selected_text
    }}</a>
    <transition name="gas-select">
      <div class="downlayer brandLayer moreautoLayer" v-show="is_show" :style="position">
        <div class="downlayerTitle">
          <p><a href="javascript:;" :class="selected_class" @click="save" >确认</a><a href="javascript:;" @click="cancel">取消</a></p>
          <a v-for="(letter, index) in letters" :key="index" @click="switch_option(letter)" :class="letter === current_letter ? 'titleCur' : ''" href="javascript:;">{{ letter.letter === '-' ? '全部' : letter.letter }}</a>
        </div>
        <div class="downlayerBox">
          <ul>
            <li v-for="(option, index) in current_category" :key="index" 
                :class="value.indexOf(option.value) >= 0 || value.indexOf(Object.values(option)[0]) >= 0 ? 'checked' : ''"
                >
              <a @click="choice(option)" href="javascript:;">{{ Object.values(option)[data_index] }}</a>
            </li>
          </ul>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>

import HanziToPinyin from "@/utils/pinyin";
// import { stringify } from 'qs';

export default {
  name: "select-letters",
  props: {
    value: Array,
    text: String,
    position: String,
    width: Number,
    options: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      selected_text: this.text,
      selected_class: "",
      letters:[],
      current_letter: '-',
      current_category: [],
      data_index: 1,// 文本数据位置
      is_show: false,
    };
  },
  computed:{
    options_new(){
      return JSON.parse(JSON.stringify(this.options))
    }
  },
  watch: {
      options_new(new_val, old_val) {
        if(JSON.stringify(new_val) != JSON.stringify(old_val)){
            // this.selected_text = this.text;
            // this.$emit("input", 0);
        }
        if(new_val){
          this.data_index = typeof(Object.values(new_val[0])[1]) === 'string' ? 1 : 2;
          this.letters = this.letter_sort(this.options_new);
          this.switch_option(Object.values(this.letters)[0]);
        }
      },
      value(new_val){
      if(new_val.length === 0)
      {
        this.selected_class = "comitbut";
      }else
      {
        this.selected_class = "blueCommit";
      }
          
    }
  },
  mounted() {
    document.addEventListener("click", (e) => {
      if (this.$refs.option) {
        if (!this.$refs.option.contains(e.target)) {
          this.hide();
        }
      }
    });
  },
  methods: {
    toggle() {
      this.is_show = !this.is_show;
    },
    switch_option(letter) {
        this.current_letter = letter;
        this.current_category = Object.values(letter)[1];
    },
    choice(option) {
        
        let choiced_value = option.value || Object.values(option)[0]
    //   let choiced_text = option.text || Object.values(option)[this.data_index];
            if (this.value.indexOf(choiced_value) >= 0)
            {
                // this.selected_text_list.splice(this.selected_text_list.indexOf(choiced_text),1);
                this.value.splice(this.value.indexOf(choiced_value),1);
            }else{
                // this.selected_text_list.push(choiced_text);
                this.value.push(choiced_value);
            }

        // this.selected_text = Object.values(option)[this.data_index];
        // this.selected_class = this.selected_text === this.text ? '' : 'selected';  选项置灰
        // this.$emit("input", Object.values(option)[0]);
        // this.$emit('reset');
        // this.hide();
        // console.log(option)
    },
    save(){
      // this.selected_class = this.value === [] ? '' : 'blueBorder';  //选项置灰
      this.$emit("input", this.value);
      this.$emit("reset");
      this.hide();
    },
    cancel(){
      // this.value = [];
      // this.selected_text_list = [];
      // this.selected_text = this.text;
      // this.selected_class = '';
      this.$emit("input", []);
      this.$emit("reset");
      this.hide();
    },
    hide() {
      this.is_show = false;
    },
    letter_sort(list) {
        let _this = this;
      const groups = {};
      groups['-'] = [];
      for (let item of list) {
        const group = Object.values(item)[_this.data_index].substr(0, 1);
        // let letter = pinyin(group, {
        //   style: pinyin.STYLE_FIRST_LETTER
        // }).toString().toUpperCase();
        let letter = HanziToPinyin.instance.initialTreatment(group);
        groups[letter] = groups[letter] || [];
        groups[letter].push(item);
        groups['-'].push(item);
      }
      let sort_group = [];
      Object.keys(groups)
        .sort()
        .map(function (group) {
          sort_group.push({
            letter: group,
            group: groups[group],
          });
        });
      return sort_group;
    },
  },
};
</script>